import { ICategoryFilteringViewModel } from 'Types/Litium';
import CaretDown from 'Icons/caretGsd.svg?react';

interface IProductSortingProps {
    getFiltration: (
        param: {
            name: string;
            value: string;
        }[]
    ) => void;
    isFetching: boolean;
    sortCriteria: ICategoryFilteringViewModel;
    sortTitle: string;
}

const ProductSorting = ({
    sortCriteria,
    sortTitle,
    getFiltration,
    isFetching,
}: IProductSortingProps) => {
    const handleSortClick = (sortValue: string, selected: boolean) => {
        const trimmedValue = sortValue.substring(
            sortValue.lastIndexOf('?') + 1
        );
        const values = trimmedValue
            .split('&')
            .map(filterValue => {
                const [name, value] = filterValue.split('=');
                return { name, value: decodeURIComponent(value) };
            })
            .filter(obj => {
                if (selected) {
                    return !obj.name.includes('sort');
                }
                return true;
            });

        getFiltration(values);

        if (selected) {
            const sortIndex = sortValue.indexOf('sort');
            const resetSearch = sortValue.substring(0, sortIndex - 1);
            window.history.replaceState({}, '', resetSearch);
            return;
        }

        window.history.replaceState({}, '', sortValue);
    };

    return (
        sortCriteria && (
            <div className="flex items-center lg:gap-1">
                <p id="sortLabel" className="font-roboto text-sm font-medium">
                    {sortTitle}:
                </p>
                <div className="flex items-center lg:gap-1">
                    {sortCriteria.sortItems.map((criteria, index) => (
                        <button
                            aria-labelledby="sortLabel"
                            aria-label={criteria.text}
                            key={index}
                            type="button"
                            onClick={() =>
                                isFetching
                                    ? false
                                    : handleSortClick(
                                          criteria.value,
                                          criteria.selected
                                      )
                            }
                            className={`text-small flex h-7 w-7 items-center justify-center rounded-full p-1 font-montserrat tabular-nums text-black transition-colors duration-layout lg:h-8 lg:w-8 lg:p-1 ${
                                criteria.selected
                                    ? 'bg-romantic'
                                    : 'bg-transparent'
                            }`}
                        >
                            <span className="sr-only">{criteria.text}</span>
                            <CaretDown
                                className={`h-4.5 w-4.5 stroke-[0.5px] ${
                                    criteria.value.includes(
                                        'sort_direction=Descending'
                                    )
                                        ? '-rotate-90'
                                        : 'rotate-90'
                                }`}
                            />
                        </button>
                    ))}
                </div>
            </div>
        )
    );
};

export default ProductSorting;
